var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UtteranceControl',_vm._g(_vm._b({attrs:{"disabled-enter":true,"customText":_vm.endText}},'UtteranceControl',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }